import { Component, OnInit, OnDestroy, inject, EventEmitter, Output, ViewChild, HostListener } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { House, ChevronRight, Mail, Bell, EllipsisVertical, Ellipsis } from 'lucide-angular';
import { UsuarioService } from '../../../services/usuario.service';
import { SidebarService } from '../../../services/sidebar.service';
import { UserAccountMenuComponent } from '../../../shared/widgets/kite/user-account-menu/user-account-menu.component';
import { NotificationDropdownComponent } from '../../../shared/components/notification-dropdown/notification-dropdown.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  public readonly sidebarService = inject(SidebarService);
  private readonly usuarioService = inject(UsuarioService);
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);

  @ViewChild(UserAccountMenuComponent) account?: UserAccountMenuComponent;
  @ViewChild(NotificationDropdownComponent) notifications?: NotificationDropdownComponent;

  @Output() messagesClick = new EventEmitter<void>();
  @Output() notificationsClick = new EventEmitter<void>();
  @Output() moreClick = new EventEmitter<void>();

  readonly icons = {
    home: House,
    chevron: ChevronRight,
    mail: Mail,
    bell: Bell,
    ellipsisVertical: EllipsisVertical,
    ellipsis: Ellipsis
  };

  public pageTitle: string = 'Dashboard';
  public sectionTitle: string = '';
  private routerSub$?: Subscription;

  ngOnInit(): void {
    this.updateBreadcrumbs();
    this.routerSub$ = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateBreadcrumbs();
        this.closePanels();
      });
  }

  ngOnDestroy(): void {
    this.routerSub$?.unsubscribe();
  }

  closePanels(): void {
    this.account?.close();
    this.notifications?.closeDropdown();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent): void {
    if (this.account?.isOpen()) {
      event.preventDefault();
      this.account.close(true);
    } else if (this.notifications?.isOpen()) {
      event.preventDefault();
      this.notifications.closeDropdown(true);
    }
  }

  private updateBreadcrumbs(): void {
    let currentRoute: ActivatedRoute | null = this.activatedRoute.root;
    let title = '';
    let section = '';

    const url = this.router.url;
    if (url.startsWith('/eco')) {
      section = 'ECO';
    } else if (url.startsWith('/uco')) {
      section = 'UCO';
    } else if (url.startsWith('/management')) {
      section = 'Management';
    }

    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
      if (currentRoute.snapshot.data && currentRoute.snapshot.data['titulo']) {
        title = currentRoute.snapshot.data['titulo'];
      }
    }

    this.pageTitle = title || 'Dashboard';
    this.sectionTitle = section;
  }

  onMessagesClick(): void {
    this.messagesClick.emit();
  }

  onNotificationsClick(): void {
    this.notificationsClick.emit();
  }

  onMoreClick(): void {
    this.moreClick.emit();
  }
}
